import styled from 'styled-components'
import ReactSelect from 'react-select'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  small?: boolean
  green?: boolean
  secondary?: boolean
  disabled?: boolean
  erro?: any
  analyze?: boolean
}

export const Select = styled(ReactSelect)`
  .Select__control {
    display: flex;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    height: 50px;
    width: 200px;
    display: inline-flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding-left: 10px;
    background: ${Theme.pallete.SECONDARY};
    border: 1px solid #9c948c;
    box-sizing: border-box;
    &:hover {
      border: 1px solid #9c948cdd;
      outline: hidden;
      background-color: #8f888133;
    }
  }
  .Select__control--is-focused {
    box-shadow: 0 0 0 1px black;
    outline: hidden;

    &:hover {
      outline: hidden;
      background-color: #f5f4f3;
    }
  }
  .Select__menu {
    background-color: #fefefe;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    box-sizing: border-box;
    margin-top: 2px;
    border-radius: 5px;
    max-width: 200px;
  }
`

export const ResumeInputCard = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px 32px 24px;
  height: 114px;
  width: ${(props: IStyleProps) => {
    if (props.small) return '183px'
    // if (props.medium) return '208px'
    // if (props.semi) return '230px'
    return '252px'
  }};

  border-radius: 5px;
  border: ${(props: IStyleProps) => {
    if (props.analyze) return '1px solid #FDAB3D'
    if (props.erro) return '1px solid red'
    return 'none'
  }};
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);

  background: ${Theme.pallete.SECONDARY};

  cursor: ${(props: IStyleProps) => {
    if (props.disabled) return ''
    return 'pointer'
  }};
  .defaultIcon {
    width: 20px;
    height: 20px;
  }

  .title {
    color: ${Theme.pallete.PRIMARY};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: ${(props: IStyleProps) => {
      if (props.small) return '12px'
      return '14px'
    }};
    font-style: normal;
    font-weight: 700;
    margin: 0 0 0 8px;
    text-align: left;
    line-height: normal;
    white-space: nowrap;
    font-family: ${Theme.fontFamily.SECONDARY};
    font-weight: 700;
    letter-spacing: 0.22px;
    font-size: 16px;
  }

  .iconClickable {
    filter: ${(props: IStyleProps) => {
      if (props.disabled) return `${Theme.icons.QUINARY}`
      if (props.secondary) return ``
      if (props.green) return `${Theme.icons.QUINARY}`
      return ``
    }};
    max-width: 24px;
    height: 24px;
    margin: 0 0 12px 25px;
  }

  .fotoSpecialista {
    border-radius: 50%;
    object-fit: cover;
    width: 24px;
    height: 24px;
  }

  .editIcon {
    filter: ${(props: IStyleProps) => {
      if (props.disabled) return `${Theme.icons.QUINARY}`
      if (props.secondary) return ``
      if (props.green) return `${Theme.icons.QUINARY}`
      return ``
    }};
    max-width: 10px;
    height: 10px;
    margin: ${(props: IStyleProps) => {
      if (props.small) return '0 0 22px 175px'
      return '30px 0 22px 274px'
    }};
  }

  p {
    font-size: 12px;
    font-style: normal;
    font-weight: 300;

    text-align: left;
    line-height: 21.09px;

    margin: ${(props: IStyleProps) => {
      if (props.small) return '0 0 22px 175px'
      return '30px 0 22px 274px'
    }};
    color: ${(props: IStyleProps) => {
      if (props.disabled) return `${Theme.pallete.SECONDARY}`
      if (props.secondary) return `${Theme.pallete.SECONDARY}`
      return `${Theme.pallete.SECONDARY}`
    }};
  }
  .loading-img-button {
    width: 18px;
    height: 18px;

    animation: load 2s infinite linear;

    display: flex;
    align-self: center;
    margin-bottom: 30px;
  }
  .legend {
    white-space: nowrap;
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    margin-top: 12px;
  }
  @media only screen and (min-width: 1441px) {
    height: 128px;
    width: ${(props: IStyleProps) => {
      if (props.small) return '184px'
      // if (props.medium) return '233px'
      // if (props.semi) return '258px'
      return '284px'
    }};
  }
`

export const TextDiv = styled.div`
  // margin-top: 10px;

  display: flex;
  justify-content: start;
  align-items: center;
`
interface IErrorMsgProps {
  errorMsg?: string
}
export const ErrorMsg = styled.div<IErrorMsgProps>`
  color: #d61212;
  position: absolute;
  bottom: -6px;
  left: 0;
  font-size: 12px;
  transform: translateY(100%);
`
